const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function apiUrl(path) {
  return `${API_BASE_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}